import { css } from '@emotion/react';
import { PageProps,withPrefix } from 'gatsby';
import { ContactSection } from '@/components/general/ContactSection';
import { Layout } from '@/components/general/Layout';
import { PageHeader } from '@/components/general/PageHeader';
import { Seo } from '@/components/general/Seo';
import { ToolSection } from '@/components/page-sections/ToolSection';
// import { ExpertsSection } from '@/components/top-page/ExpertsSection';
import { DLBanner } from '@/components/general/DLBanner';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="IPO・上場準備に必要な機能一覧｜【Uniforce】クラウド型管理ツール"
      description="【Uniforce】IPO・上場準備を支援する機能を網羅。準備に必要な機能をオールインワンで提供。経験がなくても、専門家監修の機能で効率的なIPO準備を可能にするツールです。無料相談実施中。"
    />
    <PageHeader
      css={css`
        margin-bottom: 32px;

        @media ${getScreen('pc')} {
          margin-bottom: 96px;
        }
      `}
      en="FUNCTION"
      title="主な機能"
      readText={
        <>
          IPO準備業務の課題を解決し
          <br
            css={css`
              @media ${getScreen('pc')} {
                display: none;
              }
            `}
          />
          「上場までの道のりを完全サポート」するための
          <br />
          Uniforceの機能をご紹介します。
        </>
      }
    >
      <div
        css={css`
          pointer-events: none;
          position: absolute;
          right: calc(50% + 320px);
          bottom: 0;

          @media ${getScreen('pc', '未満')} {
            display: none;
          }
        `}
      >
        <img
          src={withPrefix('/images/tool/tool-human.png')}
          width="144"
          height="171"
          alt=""
        />
      </div>
    </PageHeader>
    <ToolSection />
    <DLBanner />
    <ContactSection
      css={css`
        margin-top: 120px;

        @media ${getScreen('pc')} {
          margin-top: 160px;
        }
      `}
      title1="Uniforce IPO準備クラウドで"
      title2="「IPOの準備を効率的」"
      title3="に"
      title4="進めませんか？"
      text="IPO準備クラウドの機能詳細や無料デモのご相談はこちら"
    />
  </Layout>
);

export default Page;
